import React from 'react'
import { Link } from 'gatsby'

import Layout from '../components/layout'
import Image from '../components/image'
import SEO from '../components/seo'

const IndexPage = class extends React.Component {
  constructor() {
    super()

    this.quotes = [
      {
        quote: `We didn’t come this far to come this far`,
        author: 'Anonymous',
      },
      {
        quote: `The pessimist complains about the wind.  The optimist expects it to change.  The leader adjusts the sails.`,
        author: `John Maxwell `,
      },
      {
        quote: `Ah, but a man's reach should exceed his grasp, Or what's a heaven for? `,
        author: 'Robert Browning',
      },
      {
        quote: `
        In my humdrum life, the daily battle hasn't been good versus evil. It's hardly so epic. Most days, my real battle is doing good versus doing nothing.`,
        author: 'Deidre Sullivan - NPR Essay “This I Believe”',
      },
      {
        quote: `There is a Hasidic tale that reveals with amazing brevity, both
        the universal tendency to want to be someone else and the
        ultimate importance of becoming one’s self: Rabbi Zusya, when he
        was an old man, said, in the coming world, they will not ask me:
        ‘Why were you not Moses? They will ask me: ‘Why were you not
        Zusya?’`,
        author: 'Parker Palmer',
      },
      {
        quote: `  And what did Moses learn from climbing the mountain?
        Moses, said Jacob, like the rest of us, discovered that to come
        down the mountain and live with your vision takes as much effort
        as climbing the mountain in pursuit of your vision.`,
        author: 'Noah ben Shea',
      },
      {
        quote: ` We don't see things as they are. We see them as we are.`,
        author: 'Anais Nin',
      },
      {
        quote: `Real knowledge is to know the extent of one's ignorance.`,
        author: 'Confucius',
      },
      {
        quote: ` Ah, but a man’s reach should exceed his grasp, Or what’s a
        heaven for?`,
        author: `Robert Browning`,
      },
    ]
  }
  render() {
    return (
      <Layout>
        <SEO title="Home" keywords={[]} />

        <div id="main" role="main">
          <div
            id="quote-box"
            style={{ position: 'relative', overflow: 'hidden' }}
          >
            {this.quotes.map(quote => {
              return (
                <div
                  key={quote.author}
                  style={{ opacity: '0', transition: 'opacity 2s linear 0s' }}
                >
                  <span className="quote float-right">{quote.quote}</span>

                  <span className="author float-right">
                    <em>{quote.author}</em>
                  </span>
                </div>
              )
            })}
          </div>
          <p>
            <em>Gómez &amp; Associates</em> is an international training and
            consulting firm based in Colorado Springs, Colorado. We are
            dedicated to doing our part to make the world a better place by
            helping individuals find purpose in their jobs, while creating
            shared value through organizational and individual development.
            Clients hire
            <em>Gómez &amp; Associates</em> for our vibrant and
            audience-engaging programs which have practical applications and
            lasting impact. Our philosophy is simple: spur continual learning.
            Our work propels our clients, including corporations, nonprofits,
            universities, government agencies, and family owned businesses, to
            achieve long-term results, accomplish their organizational mission
            and deliver exceptional performance and social benefit.
          </p>
        </div>
      </Layout>
    )
  }
  componentDidMount() {
    const elem = document.querySelectorAll('#quote-box div')

    let visibleElementIndex = 0
    elem[visibleElementIndex].className = 'quote-visible'
    elem[visibleElementIndex].style.opacity = 1

    setInterval(() => {
      const previousIndex = visibleElementIndex
      let newIndex = previousIndex + 1

      if (newIndex >= elem.length) {
        newIndex = 0
      }

      this.fadeOut(elem[previousIndex])
      this.fadeIn(elem[newIndex])

      visibleElementIndex = newIndex
    }, 10000)
  }

  fadeOut(element) {
    element.style.transition = 'opacity 2s linear 0s'
    element.style.opacity = 0
  }
  fadeIn(element) {
    element.style.transition = 'opacity 2s linear 0s'
    element.style.opacity = 1
    element.className = 'quote-visible'
  }

  getRandomInt(min, max) {
    min = Math.ceil(min)
    max = Math.floor(max) - 1
    return Math.floor(Math.random() * (max - min + 1)) + min
  }
}

export default IndexPage
